export var FinanceDetailsRows;
(function (FinanceDetailsRows) {
    FinanceDetailsRows["deposit"] = "deposit";
    FinanceDetailsRows["depositPercentage"] = "depositPercentage";
    FinanceDetailsRows["residualAmount"] = "residualAmount";
    FinanceDetailsRows["amountFinanced"] = "amountFinanced";
    FinanceDetailsRows["paymentValue"] = "paymentValue";
    FinanceDetailsRows["financeProductName"] = "financeProductName";
    FinanceDetailsRows["term"] = "term";
    FinanceDetailsRows["mileage"] = "mileage";
    FinanceDetailsRows["amountPayable"] = "amountPayable";
    FinanceDetailsRows["totalAmountPayable"] = "totalAmountPayable";
    FinanceDetailsRows["interestRate"] = "interestRate";
    FinanceDetailsRows["netDriveawayPrice"] = "netDriveawayPrice";
    FinanceDetailsRows["upfrontFees"] = "upfrontFees";
    FinanceDetailsRows["loanType"] = "loanType";
    FinanceDetailsRows["comparisonRate"] = "comparisonRate";
    FinanceDetailsRows["financeProduct"] = "financeProduct";
    FinanceDetailsRows["insuranceAmount"] = "insuranceAmount";
    FinanceDetailsRows["governmentEVRebate"] = "governmentEVRebate";
    FinanceDetailsRows["cae"] = "cae";
    FinanceDetailsRows["nonFinanceableAmount"] = "totalNonFinanceableFeatures";
    FinanceDetailsRows["totalFinanceAmount"] = "totalFinanceAmount";
    FinanceDetailsRows["roadCosts"] = "roadCosts";
})(FinanceDetailsRows || (FinanceDetailsRows = {}));
//# sourceMappingURL=FinanceDetailsRows.js.map